module.exports = __webpack_public_path__ + "static/media/social_media_group.75f69f05.svg";